<div class="single-instructor-member mb-30" (click)="routeToDetail(teacher)">
    <div class="member-image">
        <img *ngIf="teacher.image else elseBlock" src="{{teacher.image.fileUrl}}">
        <ng-template #elseBlock>
            <img src="assets/img/teacher-placeholder.png">
        </ng-template>
    </div>

    <div class="member-content">
        <h3><a href="javasript:;">{{teacher.name}}</a></h3>
        <span>{{teacher.position}}</span>
    </div>
</div>
